export enum AccessLevel {
  KlearlyAdmin = "KlearlyAdmin",
  KlearlySuperAdmin = "KlearlySuperAdmin",
  KlearlyAnalytics = "KlearlyAnalytics",
  KlearlySalesSuperAdmin = "KlearlySalesSuperAdmin",
  KlearlySalesAdmin = "KlearlySalesAdmin",
  CoreTechEmployee = "CoreTechEmployee",
  Partner = "Partner",
}
